import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";

/**
 * Master "สาเหตุการเสีย" (ISS-029)
 * เดิมสาเหตุหลักเป็นค่าคงที่ 6 ค่าในโค้ดแอปมือถือ เพิ่ม/แก้เองไม่ได้ ต้องรอ Dev แก้โค้ด
 * หน้านี้ให้แอดมินดูแล master เอง แล้วแอปดึงรายการเดียวกันไปแสดงตอนช่างปิดงาน
 * API: admin/root-causes (โครงเดียวกับหน้า CRUD อื่น เช่น objectives)
 */
export default class RootCauses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      page: 1,
      page_size: 10,
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      uid: "",
      company_id: company?.id,
      sequence: "",
      name_th: "",
      name_en: "",
      description: "",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search, page_size } = this.state;
    loading(true);

    // with_usage=true ให้ backend นับจำนวนใบงานที่ใช้สาเหตุนั้นมาด้วย
    // แอดมินจะได้เห็นก่อนว่าตัวไหนถูกใช้จริง (ตัวที่ถูกใช้แล้วลบไม่ได้ ต้องปิดใช้งานแทน)
    const result = await GET("admin/root-causes", {
      page_size,
      page,
      data_search: filter_search || "",
      with_usage: "true",
      uid: "",
    });

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    }

    loading(false);
  };

  CreateUpdate = async () => {
    const { uid, company_id, sequence, name_th, name_en, description, is_active } = this.state;

    if (!name_th.trim() && !name_en.trim()) {
      alert("", "warning", t("warning"), t("verify_root_cause_name"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      const body = {
        company_id,
        sequence: sequence === "" ? null : Number(sequence),
        name_th: name_th.trim(),
        name_en: name_en.trim(),
        description: description.trim(),
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/root-causes", body)
        : await PUT("admin/root-causes/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  Delete = async (item) => {
    // สาเหตุที่ถูกใช้ในใบงานแล้ว backend จะปฏิเสธการลบ - บอกตั้งแต่ตรงนี้เลยว่าให้ปิดใช้งานแทน
    if (item.usage_count > 0) {
      alert("", "warning", t("warning"), t("root_cause_in_use"));
      return;
    }

    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/root-causes/" + item.uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      sequence: String((this.state.data || []).length + 1),
      name_th: "",
      name_en: "",
      description: "",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      sequence: item.sequence != null ? String(item.sequence) : "",
      name_th: item.name_th || "",
      name_en: item.name_en || "",
      description: item.description || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  render() {
    const {
      data, count, page, page_size, filter_search, modal_create, modal_update,
      sequence, name_th, name_en, description, is_active,
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("root_causes")}</h3>
              <div className="text-secondary text-14">{t("root_causes_desc")}</div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex flex-wrap gap-2 flex-grow-1">
                <div className="position-relative">
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-350"
                    style={{ height: "38px" }}
                    placeholder={t("search_root_causes")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                  />
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                    {t("filter")}
                  </button>
                  <button
                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                    onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
                  >
                    {t("clear_all")}
                  </button>
                </div>
              </div>
              {can("root-cause.create") && (
                <button
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                  onClick={this.openCreate}
                >
                  <span className="me-2 text-16">+</span> {t("add_root_cause")}
                </button>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-4 shadow-sm overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-3 border-0 wpx-80 text-center">{t("sequence")}</th>
                    <th className="py-3 px-3 border-0">{t("root_cause_name_th")}</th>
                    <th className="py-3 px-3 border-0">{t("root_cause_name_en")}</th>
                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("used_in_jobs")}</th>
                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("status")}</th>
                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center text-secondary py-5">-</td>
                    </tr>
                  ) : (
                    data.map((item, idx) => (
                      <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                        <td className="px-3 text-center text-secondary text-14">{item.sequence ?? "-"}</td>
                        <td className="px-3">
                          <div className="text-dark text-14 fw-bold">{item.name_th || "-"}</div>
                          {item.description ? <div className="text-secondary text-12">{item.description}</div> : null}
                        </td>
                        <td className="px-3">
                          <div className="text-secondary text-14">{item.name_en || "-"}</div>
                        </td>
                        <td className="text-center">
                          <span className={`text-12 fw-bold px-2 py-1 rounded-pill ${item.usage_count > 0 ? "text-primary bg-primary-light" : "text-secondary bg-light border"}`}>
                            {item.usage_count ?? 0}
                          </span>
                        </td>
                        <td className="text-center">
                          {item.is_active ? (
                            <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                          ) : (
                            <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                          )}
                        </td>
                        <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <ActionIconButton label={can("root-cause.update") ? t("edit") : t("view")} icon={can("root-cause.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("root-cause.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                          {can("root-cause.delete") && <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item)} />}
                        </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
            <div>
              {t("showing")} {count === 0 ? 0 : (page - 1) * page_size + 1}-{(page - 1) * page_size + data.length} {t("of")} {count}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        {/* MODAL: CREATE / EDIT */}
        <Modal
          show={modal_create || modal_update}
          onHide={() => this.setState({ modal_create: false, modal_update: false })}
          centered
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit") : t("add_root_cause")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
<fieldset disabled={modal_update && !can("root-cause.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label text-14 text-dark mb-2">{t("sequence")}</label>
                <input
                  type="number"
                  className="form-control py-2"
                  value={sequence}
                  onChange={(e) => this.setState({ sequence: e.target.value })}
                />
              </div>
              <div className="col-md-8">
                <label className="form-label text-14 text-dark mb-2">
                  {t("root_cause_name_th")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control py-2"
                  value={name_th}
                  onChange={(e) => this.setState({ name_th: e.target.value })}
                />
              </div>
              <div className="col-12">
                {/* ค่าที่บันทึกลงใบงานคือชื่ออังกฤษ (visits.root_cause_type) จึงควรกรอกไว้ให้ครบ */}
                <label className="form-label text-14 text-dark mb-2">{t("root_cause_name_en")}</label>
                <input
                  type="text"
                  className="form-control py-2"
                  value={name_en}
                  onChange={(e) => this.setState({ name_en: e.target.value })}
                />
              </div>
              <div className="col-12">
                <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                <textarea
                  className="form-control py-2"
                  rows={2}
                  value={description}
                  onChange={(e) => this.setState({ description: e.target.value })}
                />
              </div>

              <div className="col-12 mt-3 border-top pt-3">
                <h6 className="fw-bold mb-3 d-flex align-items-center">
                  <span className="icon text-primary me-2">{""}</span> {t("status")}
                </h6>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="rootCauseStatus"
                      id="rootCauseActive"
                      checked={is_active === "Active"}
                      onChange={() => this.setState({ is_active: "Active" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="rootCauseActive">{t("active")}</label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="rootCauseStatus"
                      id="rootCauseInactive"
                      checked={is_active === "Inactive"}
                      onChange={() => this.setState({ is_active: "Inactive" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="rootCauseInactive">{t("inactive")}</label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
</Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false })}
            >
              {t("cancel")}
            </button>
            {(!modal_update || can("root-cause.update")) && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                onClick={this.CreateUpdate}
              >
                <span className="icon me-2">{""}</span> {t("save")}
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
